import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiStar, FiArrowRight } = FiIcons;

const Testimonials = () => {
  const videoTestimonials = [
    {
      title: "How Funnels Done Transformed My Coaching Business — A Woman Entrepreneur Coach",
      videoId: "v3EEtDIaC3w",
      duration: "3:45"
    },
    {
      title: "From Struggling to 2 Lakhs: My Funnels Done Success Story — Bridal Lead Generation Expert",
      videoId: "IrfPwkcSTB0",
      duration: "4:20"
    },
    {
      title: "Overcoming Coaching Business Challenges with Funnels Done — Coaching Business",
      videoId: "F26JiMS-w4I",
      duration: "5:15"
    },
    {
      title: "How I Made 30 Lakhs in a Year… — Professor",
      videoId: "yWzJt7jv5CM",
      duration: "6:30"
    },
    {
      title: "Want More Customers? See How Manivanan Did It — Trading Coach",
      videoId: "vRzrNK9XPmQ",
      duration: "4:45"
    }
  ];

  const writtenTestimonials = [
    {
      name: "A R Ahamed Junaith",
      role: "Spoken English Coach",
      avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=80&h=80&fit=crop&crop=face",
      quote: "21+ Lakhs revenue in 10 months while staying a college professor. My Webinar automated everything!",
      rating: 5,
      metric: "₹21L+ Revenue"
    },
    {
      name: "Maria Sundar",
      role: "Stock Trader Coach",
      avatar: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=80&h=80&fit=crop&crop=face",
      quote: "1,000+ paid members & ₹3.8L in 60 days. The automation features are game-changing.",
      rating: 5,
      metric: "1000+ Members"
    },
    {
      name: "Arjumand",
      role: "Community Growth Expert",
      avatar: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=80&h=80&fit=crop&crop=face",
      quote: "60 organic registrations, 30 show-ups, multiple sales in 1 week — zero ads spent.",
      rating: 5,
      metric: "Zero Ad Spend"
    },
    {
      name: "Subiya Fathima",
      role: "Bridal Leads Coach",
      avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=80&h=80&fit=crop&crop=face",
      quote: "₹5,999 course sold to 19 clients in one day. The conversion rate is incredible!",
      rating: 5,
      metric: "19 Sales/Day"
    },
    {
      name: "Manigandan",
      role: "FiveStar Business Coach",
      avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=80&h=80&fit=crop&crop=face",
      quote: "Tamil solopreneurs crossed ₹1 Crore in a week using our webinar funnels.",
      rating: 5,
      metric: "₹1Cr+ Generated"
    },
    {
      name: "Bindhu Madhavan",
      role: "Business Consultant",
      avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=80&h=80&fit=crop&crop=face",
      quote: "Built ₹3.8L with 1,000 paid members in 60 days. The platform scales beautifully.",
      rating: 5,
      metric: "₹3.8L in 60 Days"
    }
  ];

  return (
    <section id="testimonials" className="py-12 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          className="text-center mb-12 md:mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold mb-4 md:mb-6 text-gray-900">
            🎬 Success Stories — <span className="gradient-text">Real Entrepreneurs</span>
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
            See how coaches like you are transforming their businesses with My Webinar
          </p>
        </motion.div>

        {/* Video Testimonials */}
        <motion.div
          className="mb-12 md:mb-20"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <h3 className="font-serif text-xl md:text-2xl font-bold text-center mb-6 md:mb-8 text-gray-900">Watch Their Success Stories</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {videoTestimonials.map((video, index) => (
              <motion.div
                key={index}
                className="blue-card-shine rounded-xl overflow-hidden shadow-lg border border-blue-300"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                whileHover={{ scale: 1.02, transition: { duration: 0.2 } }}
              >
                <div className="video-container">
                  <iframe
                    src={`https://www.youtube.com/embed/${video.videoId}`}
                    title={video.title}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    loading="lazy"
                  />
                </div>
                <div className="p-3 md:p-4 bg-gradient-to-br from-primary-blue to-light-blue">
                  <h4 className="text-white font-semibold text-xs md:text-sm line-clamp-2 mb-2">{video.title}</h4>
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-blue-100">{video.duration}</span>
                    <span className="text-xs text-gold font-bold bg-gold/20 px-2 py-1 rounded">EXCLUSIVE</span>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* Written Testimonials */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <h3 className="font-serif text-xl md:text-2xl font-bold text-center mb-6 md:mb-8 text-gray-900">What Our Clients Say</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 mb-8 md:mb-12">
            {writtenTestimonials.map((testimonial, index) => (
              <motion.div
                key={index}
                className="golden-card-shine rounded-xl p-6 shadow-xl border-2 border-gold"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                whileHover={{ scale: 1.05, boxShadow: "0 20px 40px rgba(245, 158, 11, 0.4)", transition: { duration: 0.3 } }}
              >
                {/* Rating */}
                <div className="flex items-center space-x-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <SafeIcon key={i} icon={FiStar} className="text-gold text-sm" />
                  ))}
                </div>

                {/* Quote */}
                <blockquote className="text-gray-900 mb-6 italic text-sm md:text-base font-medium">
                  "{testimonial.quote}"
                </blockquote>

                {/* Author Info */}
                <div className="flex items-center space-x-3 mb-4">
                  <img
                    src={testimonial.avatar}
                    alt={testimonial.name}
                    className="w-10 h-10 md:w-12 md:h-12 rounded-full object-cover border-2 border-gold"
                    loading="lazy"
                  />
                  <div>
                    <div className="font-semibold text-gray-900 text-sm md:text-base">{testimonial.name}</div>
                    <div className="text-xs md:text-sm text-gray-700">{testimonial.role}</div>
                  </div>
                </div>

                {/* Metric Badge */}
                <div className="bg-gold/20 backdrop-blur-sm border border-gold rounded-lg px-3 py-2 text-center">
                  <span className="text-gray-900 font-bold text-xs md:text-sm">{testimonial.metric}</span>
                </div>
              </motion.div>
            ))}
          </div>

          {/* CTA */}
          <div className="text-center">
            <motion.button
              className="shake-shine-cta bg-primary-blue hover:bg-dark-blue text-white px-6 md:px-8 py-3 md:py-4 rounded-xl font-bold text-base md:text-lg transition-all border-2 border-gold flex items-center space-x-2 mx-auto"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' })}
            >
              <span>Join Successful Coaches</span>
              <SafeIcon icon={FiArrowRight} />
            </motion.button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Testimonials;